import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Done as DoneIcon, MoreVert as MoreVertIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import FlatButton from '../../../../components/FlatButton'
import GitLabProviderLogo from '../../../../components/GitLabProviderLogo'
import ProviderActions from '../../../../components/ProviderActions'
import RowInfo from '../../../../components/Row/RowInfo'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps from '../../../../hooks/useMutationProps'
import {Breakpoint} from '../../../../types/constEnums'
import GitLabClientManager from '../../../../utils/GitLabClientManager'
import ConnectButton from './ConnectButton'
import GitLabConfigMenu from './GitLabConfigMenu'






graphql`
  fragment GitLabProviderRowTeamMember on TeamMember {
    integrations {
      gitlab {
        auth {
          provider {
            id
            scope
          }
        }
        cloudProvider {
          id
          clientId
          serverBaseUrl
        }
        sharedProviders {
          id
          clientId
          serverBaseUrl
        }
      }
    }
  }
`

const GitLabProviderRow = (props) => {
  const {teamId, viewerRef} = props
  const atmosphere = useAtmosphere()
  const mutationProps = useMutationProps()
  const {submitting, error} = mutationProps
  const openOAuth = (providerId, clientId, serverBaseUrl) => {
    GitLabClientManager.openOAuth(
      atmosphere,
      providerId,
      clientId,
      serverBaseUrl,
      teamId,
      mutationProps
    )
  }
  const {
    originRef: menuRef,
    menuPortal,
    menuProps,
    togglePortal
  } = useMenu(MenuPosition.UPPER_RIGHT)
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)

  const viewer = useFragment(
    graphql`
      fragment GitLabProviderRow_viewer on User {
        teamMember(teamId: $teamId) {
          ...GitLabProviderRowTeamMember @relay(mask: false)
        }
      }
    `,
    viewerRef
  )
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {gitlab} = integrations
  const {auth, cloudProvider, sharedProviders} = gitlab
  const connected = !!auth
  const connectedProviderId = _optionalChain([auth, 'optionalAccess', _ => _.provider, 'optionalAccess', _2 => _2.id])
  const availableProviders = [...(cloudProvider ? [cloudProvider] : []), ...sharedProviders]

  if (availableProviders.length === 0) return null

  return (
    _jsxs(_Fragment, { children: [
      _jsx('div', { className: "relative my-4 flex w-full shrink-0 flex-col justify-start rounded-sm bg-white shadow-card"         , children: 
        _jsxs('div', { className: "flex justify-start p-row-gutter pb-0"   , children: [
          _jsx(GitLabProviderLogo, {} )
          , _jsx('div', { className: "flex w-full flex-col"  , children: 
            availableProviders.map(({id, serverBaseUrl, clientId}) => {
              const showProvider = !connected || id === connectedProviderId
              const isCloudProvider = _optionalChain([cloudProvider, 'optionalAccess', _3 => _3.id]) === id
              if (!showProvider) return null
              return (
                _jsxs('div', { className: "flex w-full flex-row pb-4"   , children: [
                  _jsxs(RowInfo, { children: [
                    _jsx('div', { className: "mr-4 flex items-center align-middle leading-6 font-semibold text-slate-700"      , children: 
                      isCloudProvider ? 'GitLab' : serverBaseUrl.replace(/https:\/\//, '')
                    })
                    , _jsx(RowInfoCopy, { children: 
                      isCloudProvider
                        ? 'Use GitLab Issues from within Parabol.'
                        : 'Connect to your own GitLab server.'
                    })
                    , !!_optionalChain([error, 'optionalAccess', _4 => _4.message]) && (
                      _jsx('div', { className: "text-sm text-tomato-500 [&_a]:font-semibold [&_a]:text-tomato-500 [&_a]:underline"    , children: 
                        error.message
                      })
                    )
                  ]})
                  , _jsxs(ProviderActions, { children: [
                    !connected && (
                      _jsx(ConnectButton, {
                        onConnectClick: () => openOAuth(id, clientId, serverBaseUrl),
                        submitting: submitting,}
                      )
                    )
                    , id === connectedProviderId && (
                      _jsx(_Fragment, { children: 
                        isDesktop ? (
                          _jsxs(_Fragment, { children: [
                            _jsxs('div', { className: "flex items-center pr-6"  , children: [
                              _jsx(DoneIcon, { className: "h-[18px] w-[18px] text-lg text-success-light"   ,} )
                              , _jsx('div', { className: "pl-[6px] text-sm font-semibold text-slate-700"   , children: "Connected"

                              })
                            ]})
                            , _jsx(FlatButton, {
                              className: "min-w-[30px] border-slate-400 pr-0 pl-0 text-sm font-semibold text-slate-700"      ,
                              onClick: togglePortal,
                              ref: menuRef,
 children: 
                              _jsx(MoreVertIcon, { className: "h-[18px] w-[18px] text-lg"  ,} )
                            })
                          ]})
                        ) : (
                          _jsx(FlatButton, {
                            className: "min-w-[36px] border-slate-400 pr-0 pl-0 text-sm font-semibold text-slate-700"      ,
                            onClick: togglePortal,
                            ref: menuRef,
 children: 
                            _jsx(MoreVertIcon, {} )
                          })
                        )
                      })
                    )
                  ]})
                ]}, id)
              )
            })
          })
        ]})
      })
      , menuPortal(
        _jsx(GitLabConfigMenu, { menuProps: menuProps, mutationProps: mutationProps, teamId: teamId,} )
      )
    ]})
  )
}

export default GitLabProviderRow
